export const SearchTypes = {
  ALL: 'All',
  TRANSCRIPTS: 'Transcripts',
  NOTES: 'Notes',
  CLIPS: 'Clips',
  REPORTS: 'Reports',
  HIGHLIGHTS: 'Highlights',
};

export function optionsIncludes(activeItem) {
  switch (activeItem) {
    case SearchTypes.ALL:
      return {
        isTranscripts: true,
        isNotesAndClips: true,
        isReports: true,
        isHighlights: true,
      };
    case SearchTypes.TRANSCRIPTS:
      return {
        isTranscripts: true,
        isNotesAndClips: false,
        isReports: false,
        isHighlights: false,
      };
    case SearchTypes.NOTES:
      return {
        isTranscripts: false,
        isNotesAndClips: true,
        isReports: false,
        isHighlights: false,
      };
    case SearchTypes.CLIPS:
      return {
        isTranscripts: false,
        isNotesAndClips: true,
        isReports: false,
        isHighlights: false,
      };
    case SearchTypes.REPORTS:
      return {
        isTranscripts: false,
        isNotesAndClips: false,
        isReports: true,
        isHighlights: false,
      };
    case SearchTypes.HIGHLIGHTS:
      return {
        isTranscripts: false,
        isNotesAndClips: false,
        isReports: false,
        isHighlights: true,
      };
    default:
      return {
        isTranscripts: true,
        isNotesAndClips: true,
        isReports: true,
        isHighlights: true,
      };
  }
}
